<p>error-new-wallet-step works!</p>
